"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderFocusedImage = exports.calcOffsetY = exports.calcOffsetX = void 0;
var _react = _interopRequireWildcard(require("react"));
var _imageFocus = require("image-focus");
var _lodash = require("lodash");
require("./FocusedImage.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const calcOffsetX = (x, width) => {
  // take pixel value for x axis from contentful and convert to correct format
  let result = (x / width * 2 - 1).toFixed(2);
  if (result > 1) {
    // highest X value can be 1, so anything over should return 1
    return 1;
  } else if (result < -1) {
    // lowest X value can be -1, so anything under should return 1
    return -1;
  } else {
    return result;
  }
};
exports.calcOffsetX = calcOffsetX;
const calcOffsetY = (y, height) => {
  // take pixel value for y axis from contentful and convert to correct format
  let result = (y / height * 2 - 1).toFixed(2) * -1;
  if (result > 1) {
    // highest Y value can be 1, so anything over should return 1
    return 1;
  } else if (result < -1) {
    // lowest Y value can be -1, so anything over should return 1
    return -1;
  } else {
    return result;
  }
};
exports.calcOffsetY = calcOffsetY;
const renderFocusedImage = props => {
  const {
    focalPointImage,
    alt,
    imageSizes,
    fullHeightWrapper,
    pictureStyles,
    quality,
    lazyLoad = true,
    disableImageCompression = false,
    contentfulId,
    tab
  } = props;
  const focusX = focalPointImage?.x,
    focusY = focalPointImage?.y,
    imageHeight = focalPointImage?.height,
    imageWidth = focalPointImage?.width,
    imageUrl = focalPointImage?.url,
    // breakpoints based on global scss vars: globalVars.$breakpoint-xs, globalVars.$breakpoint-sm, globalVars.$breakpoint-lg
    breakPoints = {
      large: 1800,
      medium: 960,
      small: 640
    };
  const loadSetting = lazyLoad === false ? "eager" : "lazy";
  let imageQuality = 90;
  if (disableImageCompression || focalPointImage?.disableImageCompression) {
    // if checkbox is checked in contentful, disable Contentful Image API compression and return the supplied image as-is.
    imageQuality = null;
  } else if (quality && typeof quality === "number") {
    imageQuality = quality;
  }
  const qualityQueryString = imageQuality != null ? "&q=" + imageQuality : "";
  const [wrapperElemWidth, setWrapperElemWidth] = (0, _react.useState)(1200);
  const [currentBreakpointSize, setCurrentBreakpointSize] = (0, _react.useState)("desktop");
  const [isLoaded, setLoaded] = (0, _react.useState)(false);
  const [aspectRatio, setAspectRatio] = (0, _react.useState)("16 / 9");
  const wrapperElem = (0, _react.useRef)();
  const imageElem = (0, _react.useRef)();
  const resizeEventHandler = (0, _lodash.throttle)(() => {
    if (wrapperElem?.current?.offsetWidth) {
      updateFocusedImageWrapper();
    }
  }, 1000);
  (0, _react.useEffect)(() => {
    if (typeof window !== "undefined") {
      // once DOM loaded, replace placeholder with correctly sized image specified in wrapper
      updateFocusedImageWrapper();
      window.addEventListener("resize", resizeEventHandler);
      if (imageElem && imageElem?.current) {
        imageElem?.current.setAttribute("data-focus-x", calcOffsetX(focusX, imageWidth));
        imageElem?.current.setAttribute("data-focus-y", calcOffsetY(focusY, imageHeight));
        new _imageFocus.FocusedImage(imageElem?.current);
      }
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", resizeEventHandler);
      }
    };
  });
  const determineCurrentBreakpoint = () => {
    // reads element wrapper width + sets breakpoint state object
    if (wrapperElemWidth <= breakPoints.small) {
      setCurrentBreakpointSize("mobile");
    } else if (wrapperElemWidth <= breakPoints.medium) {
      setCurrentBreakpointSize("tablet");
    } else {
      setCurrentBreakpointSize("desktop");
    }
  };
  const calcWrapperAspectRatio = (width, height) => {
    if (width && height) {
      // calculate aspect ratio from supplied manual values - for use in Luna components
      return `${width} / ${height}`;
    } else if (imageWidth & imageHeight) {
      // calculate aspect ratio from supplied image file values
      return `${imageWidth} / ${imageHeight}`;
    } else {
      // return a default value - 16:9
      return "16 / 9";
    }
  };
  const constructImageUrl = function (imageHeight) {
    let format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "webp";
    if (imageHeight) {
      return imageUrl + `?fm=${format}&h=` + imageHeight + qualityQueryString;
    } else {
      return imageUrl + `?fm=${format}` + qualityQueryString;
    }
  };
  const imagesArray = {
    desktop2xImage: imageSizes?.desktop ? constructImageUrl(imageSizes?.desktop?.height * 2) : null,
    desktop2xImageAvif: imageSizes?.desktop ? constructImageUrl(imageSizes?.desktop?.height * 2, "avif") : null,
    desktopImage: imageSizes?.desktop ? constructImageUrl(imageSizes?.desktop?.height) : null,
    desktopImageAvif: imageSizes?.desktop ? constructImageUrl(imageSizes?.desktop?.height, "avif") : null,
    desktopImageRatio: imageSizes?.desktop?.ratio ? calcWrapperAspectRatio(imageSizes?.desktop?.ratio?.width, imageSizes?.desktop?.ratio?.height) : calcWrapperAspectRatio(),
    tabletImage: imageSizes?.tablet ? constructImageUrl(imageSizes?.tablet?.height) : null,
    tabletImageAvif: imageSizes?.tablet ? constructImageUrl(imageSizes?.tablet?.height, "avif") : null,
    tabletImageRatio: imageSizes?.tablet?.ratio ? calcWrapperAspectRatio(imageSizes?.tablet?.ratio?.width, imageSizes?.tablet?.ratio?.height) : calcWrapperAspectRatio(),
    mobileImage: imageSizes?.mobile ? constructImageUrl(imageSizes?.mobile?.height) : null,
    mobileImageAvif: imageSizes?.mobile ? constructImageUrl(imageSizes?.mobile?.height, "avif") : null,
    mobileImageRatio: imageSizes?.mobile?.ratio ? calcWrapperAspectRatio(imageSizes?.mobile?.ratio?.width, imageSizes?.mobile?.ratio?.height) : calcWrapperAspectRatio()
  };
  const returnImageSources = () => {
    let sourcesArray = [];
    if (imagesArray?.mobileImageAvif) {
      sourcesArray?.push( /*#__PURE__*/_react.default.createElement("source", {
        type: "image/avif",
        media: "(max-width: 600px)",
        srcSet: imagesArray?.mobileImageAvif?.startsWith("http") ? imagesArray?.mobileImageAvif : `https:${imagesArray?.mobileImageAvif}`
      }));
    }
    if (imagesArray?.mobileImage) {
      sourcesArray?.push( /*#__PURE__*/_react.default.createElement("source", {
        type: "image/webp",
        media: "(max-width: 600px)",
        srcSet: imagesArray?.mobileImage?.startsWith("http") ? imagesArray?.mobileImage : `https:${imagesArray?.mobileImage}`
      }));
    }
    if (imagesArray?.tabletImageAvif) {
      sourcesArray?.push( /*#__PURE__*/_react.default.createElement("source", {
        type: "image/avif",
        media: "(max-width: 1200px)",
        srcSet: imagesArray?.tabletImageAvif?.startsWith("http") ? imagesArray?.tabletImageAvif : `https:${imagesArray?.tabletImageAvif}`
      }));
    }
    if (imagesArray?.tabletImage) {
      sourcesArray?.push( /*#__PURE__*/_react.default.createElement("source", {
        type: "image/webp",
        media: "(max-width: 1200px)",
        srcSet: imagesArray?.tabletImage?.startsWith("http") ? imagesArray?.tabletImage : `https:${imagesArray?.tabletImage}`
      }));
    }
    if (imagesArray?.desktop2xImageAvif && imagesArray?.desktopImageAvif) {
      sourcesArray?.push( /*#__PURE__*/_react.default.createElement("source", {
        type: "image/avif",
        media: tab ? "" : "(max-width: 1800px",
        srcSet: imagesArray?.desktopImageAvif?.startsWith("http") ? imagesArray?.desktopImageAvif : `https:${imagesArray?.desktopImageAvif}`
      }), /*#__PURE__*/_react.default.createElement("source", {
        type: "image/avif",
        srcSet: imagesArray?.desktop2xImageAvif?.startsWith("http") ? imagesArray?.desktop2xImageAvif : `https:${imagesArray?.desktop2xImageAvif}`
      }));
    } else if (imagesArray?.desktopImageAvif) {
      sourcesArray?.push( /*#__PURE__*/_react.default.createElement("source", {
        type: "image/avif",
        srcSet: imagesArray?.desktopImageAvif?.startsWith("http") ? imagesArray?.desktopImageAvif : `https:${imagesArray?.desktopImageAvif}`
      }));
    }
    if (imagesArray?.desktopImage && imagesArray?.desktop2xImage) {
      sourcesArray?.push( /*#__PURE__*/_react.default.createElement("source", {
        type: "image/webp",
        media: tab ? "" : "(max-width: 1800px",
        srcSet: imagesArray?.desktopImage?.startsWith("http") ? imagesArray?.desktopImage : `https:${imagesArray?.desktopImage}`
      }), /*#__PURE__*/_react.default.createElement("source", {
        type: "image/webp",
        srcSet: imagesArray?.desktop2xImage?.startsWith("http") ? imagesArray?.desktop2xImage : `https:${imagesArray?.desktop2xImage}`
      }));
    } else if (imagesArray?.desktopImage) {
      sourcesArray?.push( /*#__PURE__*/_react.default.createElement("source", {
        type: "image/webp",
        srcSet: imagesArray?.desktopImage?.startsWith("http") ? imagesArray?.desktopImage : `https:${imagesArray?.desktopImage}`
      }));
    }
    return sourcesArray;
  };
  const determineCorrectImageRatio = () => {
    if (currentBreakpointSize === "mobile" && imagesArray?.mobileImageRatio) {
      // if specific mobile aspect ratio provided, set wrapper ratio
      setAspectRatio(imagesArray?.mobileImageRatio);
    } else if (currentBreakpointSize === "tablet" && imagesArray?.tabletImageRatio) {
      // if specific tablet aspect ratio provided, set wrapper ratio
      setAspectRatio(imagesArray?.tabletImageRatio);
    } else if (imagesArray?.desktopImageRatio) {
      setAspectRatio(imagesArray?.desktopImageRatio);
    } else {
      return setAspectRatio(calcWrapperAspectRatio());
    }
  };
  const updateFocusedImageWrapper = () => {
    // update state with wrapper element width
    setWrapperElemWidth(wrapperElem?.current?.offsetWidth);
    // set breakpoint state object, based on wrapper elem width
    determineCurrentBreakpoint();
    // set correct image ratio + wrapper ratio
    determineCorrectImageRatio();
  };
  const classFriendlyName = name => {
    // returns a 'slugified' name for targeting with focusedImage functionality below - this should be unique
    return name ? name.toLowerCase().replace(/[^\w ]+/g, " ").replace(/ +/g, "-") : "";
  };
  const imageName = classFriendlyName(focalPointImage?.title);
  const generatePlaceholder = imageUrl => {
    // generates a 50px by 50px placeholder for image on DOM load
    return imageUrl + "?fm=jpg&fl=progressive&w=50&h=50" + qualityQueryString;
  };
  const containerStyles = Object.assign({
    aspectRatio: aspectRatio,
    height: fullHeightWrapper ? "100%" : "auto"
  }, pictureStyles);
  if (focalPointImage) {
    return /*#__PURE__*/_react.default.createElement("picture", {
      ref: wrapperElem,
      className: `ter-focused-image-container`,
      style: containerStyles,
      "data-sb-object-id": contentfulId ? contentfulId : null
    }, returnImageSources() && returnImageSources().map((item, i) => {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: i
      }, item);
    }), /*#__PURE__*/_react.default.createElement("img", {
      loading: loadSetting,
      ref: imageElem,
      src: `https:${generatePlaceholder(imageUrl)}`,
      alt: alt ? alt : "",
      className: `ter-focused-image ${"focused-image-" + imageName}`,
      style: {
        opacity: isLoaded || imageElem?.current?.complete ? 1 : 0
      },
      onLoad: e => setLoaded(true)
    }));
  } else {
    return;
  }
};
exports.renderFocusedImage = renderFocusedImage;